import React from 'react';

import { Wrapper } from './Block.jsx';
import { EmptyPlaceholder } from '../utility/BuilderBlock.jsx';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function ContactImageComponent(props) {
    let data = props.data || {};
    if (data.Contact) {
        data = data.Contact;
    }
    if (!data.Image || !data.Image.S3Id) {
        if (props.builder) {
            return <EmptyPlaceholder fullWidth={true} />
        }
        return null;
    }
    const { contentStyle, imageStyle, isCropped, width, wrapperStyle } = Utilities.parseImageWrapperConfig(props.blockConfig, props);
    const columnWidth = props.columnWidth || 600;
    const imageSize = columnWidth * 2.0;
    let imageWidth = width;
    let transforms = 'c_fit';
    if (props.blockConfig && props.blockConfig.block && props.blockConfig.block.isCropped) {
        transforms = `h_${imageSize},c_fill`;
    } else if (data.Image.Height > data.Image.Width) {
        imageWidth *= (data.Image.Width / data.Image.Height);
    } else {
        imageWidth -= 0.5;
    }
    const imageUrl = Utilities.imageUrl({ extension: data.Image.Extension, id: data.Image.S3Id }, imageSize, transforms);
    let content = (
        <img
            align="center"
            alt={data.Title}
            className="SharedImage"
            height={isCropped ? width : undefined}
            src={imageUrl}
            style={imageStyle}
            width={width} />
    );
    // if (inventoryLink && inventoryLink.length > 0) {
    //     content = (
    //         <a
    //             href={inventoryLink}
    //             style={{ display: 'block' }}
    //             target="_blank"
    //             title="">{content}</a>
    //     );
    // }
    return (
        <Wrapper {...props} className="SharedCaptionBlock" style={wrapperStyle}>
            <td
                align="center"
                className="SharedCaptionBlockInner"
                valign="top">
                <table
                    align="center"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="SharedCaptionBottomContent"
                    style={{ minWidth: '100%' }}
                    width="100%">
                    <tbody>
                        <tr>
                            <td
                                align="center"
                                className="SharedCaptionBottomImageContent"
                                style={contentStyle}
                                valign="middle">
                                {content}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    );
}
const ContactImageTypeConfig = {
    panel: {
        block: function () {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(true),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Use Cropped Square Image',
                        fullWidth: true,
                        group,
                        name: 'isCropped',
                        type: 'checkbox',
                        value: false
                    }
                ]
            };
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
}
const ContactImageBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.Contact.Image,
        config: {
            block: ContactImageTypeConfig.panel.block(),
            layout: ContactImageTypeConfig.panel.layout()
        },
        display: 'Contact Image',
        group,
        image: 'contact_image.png'
    };
}
export { ContactImageBlockTypeDefinition, ContactImageComponent, ContactImageTypeConfig };
